import { AppConfig } from "services/apis/config";

const STORAGE_KEY = "gulf-teachers-app-config";

export const cacheAppConfig = (config: AppConfig) => {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(config));
  } catch {
    // ignore storage errors
  }
};

export const getCachedAppConfig = (): AppConfig | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return {
      teacher_application_paywall_enabled: Boolean(parsed?.teacher_application_paywall_enabled),
      email_verification_enabled: Boolean(parsed?.email_verification_enabled),
      cv_upgrade_enabled: Boolean(parsed?.cv_upgrade_enabled),
      cv_upgrade_amount: Number(parsed?.cv_upgrade_amount) || 19.99,
    };
  } catch {
    return null;
  }
};

export const isTeacherPaywallEnabled = (): boolean => {
  const cached = getCachedAppConfig();
  if (cached) {
    return cached.teacher_application_paywall_enabled;
  }
  return process.env.REACT_APP_TEACHER_APPLICATION_PAYWALL_ENABLED === "true";
};
